import { render, staticRenderFns } from "./ComponentEditProfile.vue?vue&type=template&id=f8f1cc8c&scoped=true&lang=html"
import script from "./ComponentEditProfile.vue?vue&type=script&lang=js"
export * from "./ComponentEditProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f1cc8c",
  null
  
)

export default component.exports